import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_FEEDER_SERVICE_FORWARDER_LIST:
      return { ...action.forwarderList };
    default:
      return state;
  }
};
